<script setup>
import { computed, onMounted, ref } from 'vue';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

// Confirmação NATIVA do início do disparo em massa (substitui o window.confirm) —
// mesmo padrão visual do ConfirmDeleteCampaignDialog, mostrando os números da
// prévia que o fluxo já tem em mãos (sem chamada nova de API). É montado
// programaticamente pelo useCampaignDrip e abre sozinho; fechar sem confirmar
// (Cancelar / ESC / clique fora) cancela o início.
const props = defineProps({
  campaign: {
    type: Object,
    default: null,
  },
  // Resultado do campaigns/previewDrip: total_pending, opted_out, duplicates,
  // invalid, estimated_days.
  preview: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['confirm', 'cancel']);

const dialogRef = ref(null);
let confirmed = false;

const stats = computed(() => [
  {
    label: 'Contatos válidos',
    value: Number(props.preview?.total_pending) || 0,
    cls: 'text-n-slate-12',
  },
  {
    label: 'Opt-out/suprimidos',
    value: Number(props.preview?.opted_out) || 0,
    cls: 'text-n-amber-11',
  },
  {
    label: 'Duplicados',
    value: Number(props.preview?.duplicates) || 0,
    cls: 'text-n-slate-11',
  },
  {
    label: 'Inválidos',
    value: Number(props.preview?.invalid) || 0,
    cls: 'text-n-ruby-11',
  },
]);

const estimatedDays = computed(
  () => Number(props.preview?.estimated_days) || 0
);

const handleConfirm = () => {
  confirmed = true;
  dialogRef.value?.close();
  emit('confirm');
};

const handleClose = () => {
  if (!confirmed) emit('cancel');
};

onMounted(() => dialogRef.value?.open());
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="`Iniciar disparo — ${campaign?.title || ''}`"
    confirm-button-label="Iniciar disparo"
    cancel-button-label="Cancelar"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <template #description>
      <p class="mb-0 text-sm text-n-slate-11">
        O envio começa agora e acontece gradualmente, dentro da cota diária.
        Esta ação envia mensagens reais e não pode ser desfeita.
      </p>
    </template>
    <div class="flex flex-col gap-3">
      <div class="grid grid-cols-2 gap-2">
        <div
          v-for="item in stats"
          :key="item.label"
          class="flex flex-col gap-0.5 p-2 rounded-xl bg-n-alpha-2 border border-n-weak"
        >
          <span class="text-lg font-extrabold" :class="item.cls">
            {{ item.value }}
          </span>
          <span class="text-xs text-n-slate-10">{{ item.label }}</span>
        </div>
      </div>
      <p v-if="estimatedDays" class="text-xs text-n-slate-11">
        Duração estimada: ~{{ estimatedDays }} dia(s) de envio (pela cota
        diária configurada).
      </p>
    </div>
  </Dialog>
</template>
